import { CalculationMethodInclude } from './CalculationMethod';
import { ActivityDataSourceWithChildrenInclude } from './ActivityDataSource';
export var FindOneLogWithProductLogEntryInclude = {
    inputs: { where: { deletedAt: null }, include: { unit: true } },
    subcategory: true,
    activityDataSource: { include: ActivityDataSourceWithChildrenInclude({}) },
    calculationMethod: { include: CalculationMethodInclude },
    supplier: true,
    customer: true,
    tags: true,
    territory: true,
    errors: true,
};
export var ProductLogEntryInclude = {
    inputs: { where: { deletedAt: null }, include: { unit: true } },
    customer: true,
    errors: true,
    subcategory: true,
    activityDataSource: { include: ActivityDataSourceWithChildrenInclude({}) },
    productEmissions: {
        where: { deletedAt: null },
        include: {
            factor: true,
        },
    },
    calculationMethod: { include: CalculationMethodInclude },
    product: {
        include: {
            productEmissions: { where: { deletedAt: null } },
            productConsumptions: { where: { deletedAt: null } },
            businessUnit: true,
        },
    },
    supplier: true,
    tags: true,
    territory: { include: { continent: true } },
};
//# sourceMappingURL=ProductLogEntry.js.map